import styled from "styled-components";
import { Link } from "react-router-dom";

export const Container = styled.div`
  position: absolute;
  top: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  left: 0;
  z-index: 100;
`;

export const Content = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
`;

export const CloseContainer = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-end;
`;

export const ButtonClose = styled.button`
  font-size: 26px;
  font-weight: bold;
  border: none;
  width: 45px;
  height: 45px;
  color: #ffff;
  background: transparent;
  cursor: pointer;
  outline: unset !important;
  margin-top: 24px;
`;

export const TextWrapper = styled.div`
  background-color: #000fff;
  padding: 24px;
  max-width: 532px;
  border: 2px solid #000fff;
`;

export const TextTitle = styled.h1`
  color: #00efff;
  text-align: center;
  font-size: 32px;
  font-weight: bold;
  font-family: "Mangueira", sans-serif;
`;

export const TextSubTitle = styled.p`
  color: #ffffff;
  margin-top: 18px;
  text-align: center;
  font-size: 21px;
  font-family: "Mangueira", sans-serif;
  font-weight: 600;
`;

export const LinkTo = styled(Link)`
  color: #00efff;
  &:hover {
    color: #fff;
  }
`;
